import { render } from "./availableProvider2FA.vue?vue&type=template&id=4537f147&scoped=true"
import script from "./availableProvider2FA.vue?vue&type=script&lang=js"
export * from "./availableProvider2FA.vue?vue&type=script&lang=js"

import "./availableProvider2FA.vue?vue&type=style&index=0&id=4537f147&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4537f147"]])

export default __exports__